import * as React from "react";
import PropTypes from "prop-types";

import "./styles.css";

const BigRadio = ({ label, checked, setChecked }) => (
  <div styleName="container">
    <div styleName="outer-circle" onClick={ev => setChecked && setChecked(ev)}>
      <div styleName={"inner-circle" + (!checked ? " invisible" : "")}></div>
    </div>
    <div styleName="label">{label}</div>
  </div>
);

BigRadio.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  setChecked: PropTypes.func
};

export default BigRadio;
